import {FiBarChart2} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";

import styles from "./ChartEmptyState.module.scss";

interface ChartEmptyStateProps {
  title: string;
  message: string;
}

/** Says why there is no chart, rather than leaving an empty panel. */
export const ChartEmptyState = ({title, message}: ChartEmptyStateProps) => (
  <div className={styles.empty}>
    <Icon icon={FiBarChart2} />
    <div className={styles.title}>{title}</div>
    <div>{message}</div>
  </div>
);
